import { Route, Routes } from 'react-router-dom'
import CalendarPage from './Page'
import CalendarFormIndex from './Form'
import { useSelector } from 'react-redux'
import NoAccess from 'components/NoAccess'

export default function Calendar() {

  const { permissions } = useSelector(state => state.session)
  if (!permissions['setting.calendar']) return <NoAccess />
  
  return (
    <Routes>
      <Route path="/" element={<CalendarPage />}>
        <Route path="/:eventId" element={<CalendarFormIndex />} />
        <Route path="/:eventId/*" element={<CalendarFormIndex />} />
      </Route>
    </Routes>
  )
}
